import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import SuperCutSegmentationType from '../../../types/super-cut-segmentation-type'
import Toggle from '../../toggle'
import FieldTitle from './field-title'

const Container = styled.div`
    grid-column: span 1;
    min-width: 0;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureAutoCaptionField = ({ field }: Props) => {
    const { autoCaption, setAutoCaption, segmentationType, setFont } = useContext(CreationCaptureInfoContext)

    const toggleAutoCaption = () => {
        if (autoCaption === true) {
            setFont()
        }
        setAutoCaption(!autoCaption)
    }

    if (segmentationType !== SuperCutSegmentationType.Caption) {
        return null
    }

    return (
        <Container>
            <FieldTitle field={field} />
            <Toggle isOn={autoCaption} onToggle={toggleAutoCaption} />
        </Container>
    )
}

export default CreationCaptureAutoCaptionField
